import React from "react";
import "./CommonField.css";

function CommonSelect({
  value,
  onChange,
  options = [],
  className = "",
  selectClassName = "",
  disabled = false,
  ...props
}) {
  const wrapperClassName = [
    "common-field",
    "common-select",
    disabled ? "is-disabled" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  const controlClassName = ["common-field-control", "common-select-control", selectClassName]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={wrapperClassName}>
      <select
        value={value}
        onChange={onChange}
        className={controlClassName}
        disabled={disabled}
        {...props}
      >
        {options.map((option) => {
          const optionValue =
            typeof option === "object" ? option.value : option;
          const optionLabel =
            typeof option === "object" ? option.label : option;

          return (
            <option key={optionValue} value={optionValue}>
              {optionLabel}
            </option>
          );
        })}
      </select>
      <span className="common-select-caret">
        <i className="fas fa-chevron-down"></i>
      </span>
    </div>
  );
}

export default CommonSelect;
